import {
	RecoverPasswordSection,
	SignInSection,
	SignUpSection,
	VerificationSection,
	EmailSection,
	QRSection,
	NextCloudSection,
	AdminSSOSwitch,
	PasskeysSection
} from '..'

export const AuthSectionNavigatorConfig = {
	SignInSection: SignInSection,
	PasskeysSection: PasskeysSection,
	SignUpSection: SignUpSection,
	RecoverPasswordSection: RecoverPasswordSection,
	VerificationSection: VerificationSection,
	EmailSection: EmailSection,
	QRSection: QRSection,
	NextCloudSection: NextCloudSection,
	AdminSSOSwitch: AdminSSOSwitch
}
